import React from "react";
import {Document, Page,  StyleSheet, Text, View, Image} from "@react-pdf/renderer";
import cooknSave from "../../img/cooknSave.jpg";


/**
 * This function will display a Pdf document containing all information required to
 * cook a good meal following the recipe , with preparation's steps and ingredients list
 * @param ingredients   {object} :  contains ingredients' quantity and name
 * @param title         {string} :  document title, probably recipe's name
 * @param image         {string} :  image's url (some pb because of authorization to use image url)
 * @param steps         {array}  :  steps array
 * @return {*}
 * @constructor
 */
export const PdfDocument =({ingredients, title, image, steps})=> {

    const styles = StyleSheet.create({
        page: {
            padding: 20,
            //backgroundImage: 'url("'+image+'")',
        },
        section: {
            display: "flex",
            flexDirection:"column",
            margin: 10,
            padding: 10,
            //flexGrow: 1
        },
        title: {
            margin: 5,
            fontSize: "26px",
            fontWeight : 'bold',
            //fontFamily : "Georgia, Times, Helvetica, Verdana",
            color: "#ff6f61",
            textAlign: "center",
        },
        subtitle:{
            marginTop: 15,
            marginBottom : 5,
            fontSize: "22px",
            color: "#ff6f61",
        },
        list : {
            marginBottom : 15,
            marginTop : 5,
            marginLeft : 15
        },
        text : {
            marginBottom : 5,
            marginTop : 5,
            textAlign : "justify",
            fontSize:14
        },
        logo:{
            width:"200",
            height:"auto",
            margin : 10,
            textAlign : "center",
            alignSelf : "center"
        }
    });


    return (
        <Document>
            <Page size="A4" style={styles.page} >
                <View style={styles.section}>
                    <Image style={styles.logo}  src={cooknSave}/>
                    <Text style={styles.title}>{title}</Text>
                </View>

                <View style={styles.subtitle}><Text>Préparation : </Text></View>
                {
                    steps ?
                        <View style={styles.list}>{steps.map(function(step, i){
                            return (
                                <View key={i} style={styles.text}><Text minPresenceAhead>Etape {i} : {step} </Text></View>
                            );
                        })}</View>
                        : ""
                }

                <View style={styles.subtitle}><Text>Ingrédients : </Text></View>
                {
                    ingredients ?
                        <View style={styles.list}>{ingredients.map(function(ingredient, i){
                            return (
                                <View key={i} style={styles.text}><Text minPresenceAhead>- {ingredient.quantity} {ingredient.name}</Text></View>
                            );
                        })}</View>
                        : ""
                }
            </Page>
        </Document>
    )
};
